import React from 'react';
import styled from 'styled-components';
import { AttentionTriangleIcon } from '@rsos/assets/icons';
import { Box, Text } from '@rsos/base-components';

const TestAlertBanner = () => {
  return (
    <TestAlertBannerWrapper>
      <AttentionTriangleIcon width={16} height={16} />
      <Text size="normal">
        SYSTEM TEST. THIS IS NOT AN EMERGENCY. DO NOT DISPATCH.
      </Text>
    </TestAlertBannerWrapper>
  );
};

export default TestAlertBanner;

const TestAlertBannerWrapper = styled(Box).attrs({
  mb: 12,
  align: 'center',
  px: 20,
  py: 12,
  bg: 'lightWarning',
  color: 'lightWarningText',
  horizontal: true,
  borderRadius: 5,
  flow: 12,
})``;
